<template>
    <div style="height: 100%; display: flex; flex-direction: column;background:#FAFAFA">
        <div style="position: fixed;top: 0;left: 0;width: 100%;z-index: 1000;">
            <van-nav-bar
            title="支付成功"
            right-text="完成"
            @click-left="onClickLeft"
            @click-right="onClickRight"
            color="linear-gradient(to right, #ff9900, #ff3333)"
            />
            <div class="countdown" > 
                <img src="../assets/imgs/paysuccess_tippic_img.png" width="100%" alt="">
            </div>
        </div>
        <div style="margin-top:14rem;padding:0 10px;">
            <van-panel style="margin-bottom:0.5rem;" class="boxshadow">
                <div slot="header" style="padding: 0 16px;">
                    <div style="padding:10px 0;font-size: 1.1rem;font-weight: bold;border-bottom:1px solid #ebedf0;text-align:center;">
                        订单付款：<span style="color:#FF3333">￥{{ goodsMsg && goodsMsg.orderTiterAmount ? goodsMsg.orderTiterAmount : '' }}</span>
                    </div>
                    <div class="orderMsgBox1">
                        <van-row class="colmargin">
                            <van-col span="12">订单编号</van-col>
                            <van-col span="12" style="text-align:right">{{ orderId }}</van-col>
                        </van-row>
                        <van-row class="colmargin" style="padding: 0 0 0.5rem;">
                            <van-col span="12">收货地址</van-col>
                            <van-col span="12" style="text-align:right">{{ goodsMsg && goodsMsg.takeOver && goodsMsg.takeOver.shippingAddress ? goodsMsg.takeOver.shippingAddress : '' }}</van-col>
                        </van-row>
                    </div>
                </div>
            </van-panel>
            <div style="padding: 1rem 0 0.5rem;display: flex;justify-content: space-around;width:100%">
                <div>
                    <van-button id="buyAgain" class="buybtn" round type="info" style="background:#FF3333;border: 1px solid #FF3333;" @touchstart.prevent="goToPayAgain">继续购物</van-button>
                </div>
                <div>
                    <van-button id="lookOrder" class="buybtn" round type="info" style="background:#FAFAFA;border: 1px solid #FF9900;color:#FF9900" @touchstart.prevent="goToLookOrder">查看订单</van-button>
                </div>
            </div>
            <div style="padding:0 2rem;font-size:0.81rem;color:#999999;line-height:1.3rem;">注意：优必上不会以订单异常、系统升级为由，要求您点击任何链接进行退款操作。</div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery'
import {  NavBar, Row, Col,Panel,Button   } from "vant";
export default {
    components: {
        [NavBar.name]: NavBar,
        [Row.name]: Row,
        [Col.name]: Col,
        [Panel.name]: Panel,
        [Button.name]: Button,
       
    },
    data(){
        return{
            goodsMsg:{},
            orderId:'',
            goodsId:'',
            angencyCode:'',
        }
    },
    methods:{
        onClickRight(){
            this.$toast('测试查看订单');
            let url = 'http://youbesunstore.youbesun.com/#/myorderList'
            window.location.href = url + '?v=' + Math.random();
        },
        goToPayAgain(){
            this.$toast('测试再次购买');
            let url = `http://youbesunstore.youbesun.com?goodsId=${this.goodsId}&angencyCode=${this.angencyCode}`
            window.location.href = url + '?v=' + (new Date().getTime())
        },
        goToLookOrder(){
            this.$toast('测试查看订单');
            let url = 'http://youbesunstore.youbesun.com/#/myorderList'
            window.location.href = url +'?timestamp='+ new Date().getTime()+Math.random();
        },
        //截取ID 
        GetQueryString(name){
            var reg = new RegExp("(^|&)"+ name +"=([^&]*)(&|$)");
            var r = window.location.search.substr(1).match(reg);
            if(r!=null)return  unescape(r[2]); return null;
        },
        getUrlMsg(){
            var url = window.location.href;
            var querys = url.substring(url.indexOf('?') + 1).split('&');
            var result=[];
            for(var i=0;i<querys.length;i++){
                var temp=querys[i].split('=');
                if(temp.length<2){
                    result[temp[0]]='';
                }else{
                    result[temp[0]]=temp[1];
                }
            }
            this.orderId = result['paysuccessorderId']
            this.totalorderId = result['paysuccesstotalorderId']
            this.goodsId = result['goodsId']
            this.angencyCode = result['angencyCode']
            this.session = result['session']
            this.local.save('goodsId',this.goodsId)
            this.local.save('angencyCode',this.angencyCode)
            this.local.save('session',this.session)
            console.log(this.goodsId)
            console.log(this.angencyCode)
            console.log(this.orderId)
        },
            //   返回
        onClickLeft() { 
            this.$router.go(-1)
        },
        onClickRight(){
            window.location.href = `http://youbesunstore.youbesun.com/#/myorderList`
        }
    },
    created(){
        let pagrUrl = window.location.href
        window.location.href = pagrUrl
        this.getUrlMsg()
        if(this.orderId){
        let params ={
            session:this.local.get('session'),
            orderId:this.orderId
        }
        console.log(params)
        this.request.get("/v1/user/order/queryPayOrder",params)
            .then(res => {
                console.log(res)
                this.goodsMsg = res.data
                console.log(this.goodsMsg)

            })
            .catch(err => {
                console.log(err);
            });
        }
    },
    mounted(){
        /* // console.log($('#abcdbtn'))
        $("#buyAgain").on("click touch",function () {
            this.$toast('111');
            let url = `http://youbesunstore.youbesun.com?goodsId=${this.goodsId}&angencyCode=${this.angencyCode}`
            window.location.href = url + '?v=' + (new Date().getTime())
        })
        $("#lookOrder").on("click touch",function () {
            this.$toast('222');
            let url = 'http://youbesunstore.youbesun.com/#/myorderList'
            window.location.href = url + '?v=' + Math.random();
        }) */
    }
}
</script>

<style lang="less" scoped>
.van-nav-bar {
    background: linear-gradient(to right, #ff9900, #ff3333);
    .van-icon,
    .van-nav-bar__text,
    .van-nav-bar__title {
      color: #fff;
    }
    .van-nav-bar__title{
        font-weight: bold;
        font-size: 1.25rem;
    }
}
.orderMsgBox1{
    font-size: 0.875rem;
    font-weight: 600;
}
.colmargin{
    margin: 8px 0;
    color: #666;
}
.buybtn{
    width:8.25rem;height:2.5rem;line-height: 2.25rem;font-size: 1.125rem;
}
[class*=van-hairline]::after{
    border: none!important;
}
</style>